import Vue from 'vue'
import Vuex from 'vuex'
import { getImageUrls } from './../helpers'
Vue.use(Vuex)

const root = document.getElementsByTagName('html')[0]

export default new Vuex.Store({
  state: {
    galleryImages: [],
    galleryThumbnails: [],
    currentMarkers: [],
    canvasBgColor: '#090909',
    scrollPos: 0,
    windowSize: {
      width: root.clientWidth,
      height: root.clientHeight
    },
    vScrollOpts: {
      right: {
        origin: 'left',
        distance: '200px',
        duration: 1000
      },
      left: {
        origin: 'right',
        distance: '200px',
        duration: 1000,
        delay: 500
      }
    },
    styleBeforeLightbox:
      'visibility: visible !important; opacity: 1 !important; transform: unset !important; transition: unset !important;'
  },

  mutations: {
    SET_GALLERY_IMAGES(state, images) {
      state.galleryImages = images
    },
    SET_GALLERY_THUMBNAILS(state, images) {
      state.galleryThumbnails = images
    },
    SET_CURRENT_MARKERS(state, currentMarkers) {
      state.currentMarkers = currentMarkers
    },

    SET_WINDOW_SIZE(state, windowSize) {
      state.windowSize = windowSize
    },
    SET_SCROLL_POS(state, scrollPos) {
      state.scrollPos = scrollPos
    }
  },

  actions: {
    getGalleryImages({ commit }, { galleryImages }) {
      const images = getImageUrls(galleryImages, 'SET_GALLERY_IMAGES')
      commit('SET_GALLERY_IMAGES', images)
    },

    getGalleryThumbnails({ commit }, { galleryThumbnails }) {
      const images = getImageUrls(galleryThumbnails, 'SET_GALLERY_THUMBNAILS')
      commit('SET_GALLERY_THUMBNAILS', images)
    },
    getCurrentMarkers({ commit }, { currentMarkers }) {
      commit('SET_CURRENT_MARKERS', currentMarkers)
    },
    getWindowSize({ commit }, windowSize) {
      commit('SET_WINDOW_SIZE', windowSize)
    },
    getScrollPos({ commit }, el) {
      let pos = el.getBoundingClientRect().top / el.offsetTop
      pos = Math.min(1 - pos, 1)
      commit('SET_SCROLL_POS', pos)
    }
  }
})
